// Authored by opencode-go/glm-5.3; Matthew, Hermes and unslop editing pass.
export const carePushCopy = {
  "notificationsTitle": "Alerts",
  "enableAlerts": "Turn on alerts",
  "disableAlerts": "Turn off alerts on this device",
  "alertsOn": "Alerts are on for new messages and assigned tasks.",
  "alertsOff": "Alerts are off. You'll only see new messages and tasks when you open the app.",
  "alertsDenied": "Alerts are blocked for this app. Check your device settings to allow them.",
  "alertsUnavailable": "Alerts aren't available here. On iPhone or iPad, add this app to your Home Screen and open it there to turn them on.",
  "alertsError": "We couldn't change your alert settings. Please try again.",
  "alertsSaving": "Saving your alert settings...",
  "homeScreenHelp": "On iPhone or iPad: tap Share, choose 'Add to Home Screen', then open the app from your Home Screen and turn on alerts there. Alert previews never show message or task details.",
  "emptySpace": "Nothing here yet. Your practitioner needs to connect your account before your messages and tasks appear.",
  "refresh": "Refresh",
  "taskLogTitle": "Your tasks"
}
